import Mixpanel from "../../config/mixpanel-config";
import { setAnalyticsCommonEvent } from "./setAnalyticsCommonEvent";

export function setMixpanelEventForSignUpRequestSuccess(email : string) {
    const event = "Email sent for sign up";
    const data : any = {
      Email: email,
      "Sign-up type": "Self"
    };
    setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForSignUpRequestFail(email : string, reason : string) {
    const event = "Request failed for sign up";
    const data : any = {
      Email: email,
      "Sign-up type": "Self",
      Reason: reason 
    };
    setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForSignUpComplete(email : string, signUpType : string, lastSentEmailSubject : string) {
    const event = "Sign up completed";
    const data : any = {
      Email: email,
      "Sign-up type": signUpType,
      "Email Subject:": lastSentEmailSubject
    };
    setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForSignUpFail(email : string, reason : string, signUpType : string) {
    const event = "Sign up failed";
    const data : any = {
      Email: email,
      Reason: reason,
      "Sign-up type": signUpType
    };
    setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForAccountCreationSuccess(email : string) {
  const event = "Account created";
  const data : any = {
    Email: email
  };
  setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForAccountCreationFail(email : string, reason : string) {
  const event = "Account creation failed";
  const data : any = {
    Email: email,
    Reason: reason
  };
  setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForAuth0SignUpSuccess(email: string, provider: string) {
  const event = "Sign up completed";
  const data: any = {
    Email: email,
    "Sign-up type": provider,
  };
  setAnalyticsCommonEvent(email, event, data);
}

export function setMixpanelEventForAuth0SignInSuccess(email: string, name: string, organizationName: string) {
  const event = "Sign in";
  const data: any = {
    Email: email,
    Name: name,
    Organization: organizationName,
  };
  setAnalyticsCommonEvent(email, event, data);
}